import type { FC, SVGProps } from 'react';

/**
 * Lightbulb glyph for the "Recommended" row on medium / opportunity AI Insight
 * cards (Figma node 248:20048). 13.83 x 22.91 — a tall, narrow bulb, so it must
 * not be squared off to a 16x16 box.
 */
export const InsightRecommendedIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    width="13.83"
    height="22.91"
    viewBox="0 0 13.83 22.91"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.1395 15.3305C12.3405 13.2135 13.83 9.25225 13.83 6.69772C13.83 3.00483 10.7273 0 6.915 0C3.10231 0 3.27147e-06 3.00483 3.27147e-06 6.69772C3.27147e-06 9.27915 1.46487 13.1664 3.64847 15.2901C3.178 15.6601 2.87697 16.2241 2.87697 16.8566V20.2196C2.87697 21.3338 3.80992 22.2374 4.96022 22.2374H5.43173C5.58624 22.5952 5.88484 22.91 6.33308 22.91H7.33825C7.7865 22.91 8.11426 22.5952 8.28891 22.2374H8.77951C9.92981 22.2374 10.8628 21.3338 10.8628 20.2196V16.8566C10.8628 16.2462 10.5819 15.7004 10.1395 15.3305ZM4.29358 20.3982C4.27726 20.341 4.2658 20.2818 4.2658 20.22V18.789L9.42567 16.6152C9.45587 16.6905 9.47393 16.7715 9.47393 16.857V18.2156L4.29358 20.3982ZM4.96022 16.1844H8.70799L4.2658 18.0555V16.857C4.2658 16.4854 4.5769 16.1844 4.96022 16.1844ZM1.38884 6.69772C1.38884 3.74637 3.8679 1.34519 6.915 1.34519C9.96176 1.34519 12.4412 3.74637 12.4412 6.69772C12.4412 9.15741 10.8423 13.1365 8.70139 14.78L8.75 14.8392H5.21195C3.05544 13.2579 1.38884 9.1823 1.38884 6.69772ZM8.77951 20.8925H4.96022C4.93244 20.8925 4.9064 20.8875 4.87932 20.8848L9.47393 18.9491V20.22C9.47393 20.5912 9.16318 20.8925 8.77951 20.8925Z"
    />
    <path
      fill="currentColor"
      d="M7.00683 7.1086C7.10058 7.1086 7.18738 7.0716 7.25301 7.01105C7.31585 6.94713 7.35405 6.85966 7.35405 6.7722C7.35405 6.68473 7.31585 6.59693 7.25301 6.53335C7.12488 6.40888 6.88877 6.40888 6.7603 6.53335C6.69745 6.59693 6.6596 6.68103 6.6596 6.7722C6.6596 6.86303 6.69745 6.94713 6.7603 7.01105C6.82592 7.0716 6.91655 7.1086 7.00683 7.1086Z"
    />
    <path
      fill="currentColor"
      d="M7.0468 7.78C6.8548 7.78 6.6996 7.93006 6.6996 8.11571V9.79429C6.6996 9.97994 6.8548 10.13 7.0468 10.13C7.2388 10.13 7.394 9.97994 7.394 9.79429V8.11571C7.394 7.93006 7.2388 7.78 7.0468 7.78Z"
    />
    <path
      fill="currentColor"
      d="M5.58254 10.15C5.67136 10.15 5.76019 10.117 5.82785 10.0514C5.96352 9.91989 5.96352 9.70727 5.82785 9.57573L4.88198 8.65866C4.74632 8.52712 4.52702 8.52712 4.39136 8.65866C4.25569 8.7902 4.25569 9.00281 4.39136 9.13435L5.33722 10.0514C5.40488 10.117 5.49371 10.15 5.58254 10.15Z"
    />
    <path
      fill="currentColor"
      d="M8.4866 10.15C8.57541 10.15 8.66421 10.117 8.73186 10.0514L9.67787 9.13435C9.81351 9.00281 9.81351 8.7902 9.67787 8.65866C9.54189 8.52712 9.32299 8.52712 9.18735 8.65866L8.24133 9.57573C8.10569 9.70727 8.10569 9.91989 8.24133 10.0514C8.30898 10.117 8.39779 10.15 8.4866 10.15Z"
    />
  </svg>
);
